import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Datatable from '../../components/datatable/Datatable'
import { AllUserRolesColumns, userAcccountTableTwoColumn, userAcccountTableTwoRows } from '../../datatablesource'
import CustomSnakebar from '../../utils/CustomSnakebar'
import { handleError } from '../../utils/error'
import newRequest from '../../utils/newRequest'

import './userRoles.scss'
import Navbar from '../../components/navbar/Navbar'
import { useTranslation } from 'react-i18next'

const UserRoles = () => {
    const [detectChange, setDetectChange] = useState(false);
    const params = useParams();
    const { id, name } = params;
const { t, i18n } = useTranslation()

    // store id in local session
    window.sessionStorage.setItem('userLoginID', JSON.stringify(id));

    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [userRolesList, setUserRolesList] = useState([]);
    const [allRolesList, setAllRolesList] = useState([]);
    // const [Snakebar, setSnakebar] = useState(false);

    useEffect(() => {
        const getAllRoles = async () => {
            try {
                const response = await newRequest.get("/GetAllUsersRoles")
                console.log(response?.data);
                if (response?.data?.length === 0) {
                    setError({ message: "No Roles found" })
                }
                setAllRolesList(response.data ?? []);
            }
            catch (error) {
                console.log(error);
                // check if the error is 401
                setAllRolesList([]);
                setError(error);
                handleError(error)
            }
        };
        const getUserRoles = async () => {
            try {
                const response = await newRequest.get("/getAllUsersRolesAssignedToUser/" + id)
                console.log(response?.data);

                setUserRolesList(response?.data ?? []);
            }
            catch (error) {
                console.log(error);
                // setError(error);
                setUserRolesList([]);
                handleError(error)
            }
        };

        getAllRoles();
        getUserRoles();
    }, [detectChange]);
    const detectAddRole = () => {
        console.log("detectAddRole");
        console.log(detectChange);
        setDetectChange(!detectChange);
    }
    return (
        <>
            {/* <Navbar /> */}
            {/* <CustomSnakebar /> */}
            {error && <CustomSnakebar message={error?.message} severity="error" />}
            <div className={`userRoleHeadingContainer items-center flex justify-between ${i18n.language==='ar'?'flex-row-reverse':"flex-row"}`}>
                <span className={`mainSpain flex ${i18n.language==='ar'?'justify-end':'justify-start'}`}>

                    <div>
                        {t("USER NAME")}: <span>{name}</span>
                    </div>
                    <div>
                        {t('USER ID')}: <span>{id}</span>
                    </div>
                </span>
                <div className="backBtnDiv">
                    <div
                        className="backBtn"
                        onClick={() => navigate(-1)}
                    >
                        {t("Go Back")}
                    </div>

                </div>

            </div>


            <div className='userRolesContainer'>


                <span>
                    <Datatable columnsName={AllUserRolesColumns(t)} data={allRolesList} actionColumnVisibility={false} title={t("ALL ROLES")} buttonVisibility={false}
                        uniqueId="userAccountRoleId"
                         secondaryColor="secondary"
                        checkboxSelectionOption={false}
                        detectAddRole={detectAddRole}
                    />

                </span>
                <span>

                    <Datatable columnsName={userAcccountTableTwoColumn(t)} data={userRolesList} actionColumnVisibility={false}
                        checkboxSelectionOption={false}
                         secondaryColor="secondary"
                        title={t("USER ROLES ASSIGNED")} buttonVisibility={false}
                        detectAddRole={detectAddRole}
                    />
                </span>

            </div>
        </>
    )
}

export default UserRoles